import Modernizr from 'modernizr';

import 'formvalidation/src/js/base';
import 'formvalidation/src/js/helper';
import 'formvalidation/src/js/framework/bootstrap';
import 'formvalidation/src/js/validator/callback';
import 'formvalidation/src/js/validator/date';
import 'formvalidation/src/js/validator/different';
import 'formvalidation/src/js/validator/emailAddress';
import 'formvalidation/src/js/validator/identical';
import 'formvalidation/src/js/validator/notEmpty';
import 'formvalidation/src/js/validator/promise';
import 'formvalidation/src/js/validator/regexp';
import 'formvalidation/src/js/validator/stringLength';
import 'formvalidation/src/js/validator/zipCode';

import validator from '../lib/validators';
/* eslint-disable class-methods-use-this */
export default class Formvalidation {
  constructor(el) {
    this.el = el;
    this.init();
  }

  init() {
    this.icons = this._getIcons();
    this.framework = 'bootstrap';
    this.trigger = 'blur';
    this.fields = this._getFieldsToValidate(
      this.el.getAttribute('data-module-form')
    );
    // Open userpic upload modal when redirections with query key = picupload
    if (this.el.getAttribute('data-module-form') === 'ownProfile') {
      if (this.el.getAttribute('data-activate-upload') === 'on') {
        document.getElementById('uploadcontainer-button').click();
      }
    }
    if (this._getBreakpoint() === 'screen-sm') {
      this._fvSmall();
    } else {
      this._fvMedium();
    }
  }

  _fvSmall() {
    $(this.el)
      .on('init.field.fv', (e, data) => {
        const $parent = data.element.parent();

        data.element.focus(() => {
          if ($parent.hasClass('has-error')) {
            data.fv.resetField(data.element);
            data.element.tooltip('destroy');
          }
        });
      })
      .formValidation({
        framework: this.framework,

        icon: this.icons,

        fields: this.fields,

        trigger: this.trigger
      });
  }

  _fvMedium() {
    $(this.el)
      .on('init.field.fv', (e, data) => {
        const $parent = data.element.parent();

        data.element.focus(() => {
          if ($parent.hasClass('has-error')) {
            data.fv.resetField(data.element);
            data.element.tooltip('destroy');
          }
        });
      })
      .formValidation({
        framework: this.framework,

        icon: this.icons,

        err: {
          container: 'tooltip'
        },

        fields: this.fields,

        trigger: this.trigger
      })
      // Revalidate when changing place
      .on('change', '#Geosearch', () => {
        const elem = $(this.el);
        setTimeout(() => {
          elem.formValidation('revalidateField', 'Geosearch');
        }, 200);
      })
      .on('err.field.fv', (e, data) => {
        // console.log('dataset', data.element.data('fv.icon'));
        const $input = data.element[0];
        const placement = $input.getAttribute('data-fv-tooltip-placement');
        const $icon = data.element.data('fv.icon');
        const title =
          $icon.data('bs.tooltip') === undefined
            ? ''
            : $icon.data('bs.tooltip').getTitle();

        $icon.tooltip('destroy');

        data.element.tooltip({
          html: true,

          placement,

          template:
            '<div class="tooltip tooltip--error" role="tooltip"><div class="tooltip-arrow tooltip__arrow--error"></div><div class="tooltip-inner tooltip__inner--error"></div></div>',

          title,

          container: 'body'
        });

        data.fv.disableSubmitButtons(false);
      })
      .on('success.field.fv', (e, data) => {
        data.element.tooltip('destroy');

        data.fv.disableSubmitButtons(false);
      })
      // Revalidate the agb_ok by changes
      .on('change', '[name="agb_ok"]', () => {
        $(this.el).formValidation('revalidateField', 'agb_ok');
      })
      // Revalidate Country by onload
      .on('keyup', '[name="PLZ"]', () => {
        // console.log('REV PLZ');
        $(this.el).formValidation('revalidateField', 'PLZ');
      })
      .on('mouseenter', '#nextBtn', () => {
        $(this.el).formValidation('validate');
      });
  }

  _getProvinces() {
    const state = $(this.el).find('[name=State]');
    $.post(
      '/ajax.php',
      {
        mode: 'getStates',
        adduser: $('#Country').val()
      },
      response => {
        $.each(response.states, (idx, val) => {
          const defaultSelected =
            idx === response.defaultState ? ' selected="selected"' : '';
          state.append(
            `<option value="${idx}"${defaultSelected}>${val}</option>\n`
          );
        });
      },
      'json'
    );
    state.attr('disabled', false).slideDown('fast');
  }

  /* eslint-disable class-methods-use-this */
  _getIcons() {
    const icons = {
      valid: 'fa fa-check',

      invalid: 'fa fa-times',

      validating: 'fa fa-refresh'
    };

    return icons;
  }

  _getBreakpoint() {
    let breakpoint;

    if (Modernizr.mq('(min-width: 992px)')) {
      breakpoint = 'screen-lg';
    } else if (Modernizr.mq('(min-width: 768px)')) {
      breakpoint = 'screen-md';
    } else {
      breakpoint = 'screen-sm';
    }

    return breakpoint;
  }

  _getFieldsToValidate(form) {
    let fields;

    switch (form) {
      case 'sendMessage':
        fields = this._sendMessageFormFields();
        break;
      case 'resetPassword':
        fields = this._resetPasswordFormFields();
        break;
      case 'sendUsername':
        fields = this._sendUsernameFormFields();
        break;
      case 'contact':
        fields = this._contactFormFields();
        break;
      case 'ownProfile':
        fields = this._ownProfileFormFields();
        break;
      default:
        fields = this._signupFormFields();
    }

    return fields;
  }

  _ownProfileFormFields() {
    const fields = {
      Email: {
        row: '.col-xs-12',

        verbose: false,

        validators: {
          notEmpty: {
            message: $(this.el)
              .find('[name=Email]')
              .attr('data-fv-notempty-message')
          },

          regexp: {
            regexp: /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i, // eslint-disable-line

            message: $(this.el)
              .find('[name=Email]')
              .attr('data-fv-regexp-message')
          }
        }
      },

      Geosearch: {
        row: '.col-xs-12',

        verbose: false,

        validators: {
          notEmpty: {
            message: $(this.el)
              .find('[name=Geosearch]')
              .attr('data-fv-notempty-message')
          }
        }
      }
    };

    return fields;
  }

  _sendMessageFormFields() {
    const fields = {
      subject: {
        verbose: false,

        validators: {
          notEmpty: {
            message: $(this.el)
              .find('[name=subject]')
              .attr('data-fv-notempty-message')
          }
        }
      },

      message: {
        verbose: false,

        validators: {
          notEmpty: {
            message: $(this.el)
              .find('[name=message]')
              .attr('data-fv-notempty-message')
          }
        }
      }
    };

    return fields;
  }

  _resetPasswordFormFields() {
    const fields = {
      passwd: {
        verbose: false,

        validators: {
          notEmpty: {
            message: $(this.el)
              .find('[name=passwd]')
              .attr('data-fv-notempty-message')
          },

          stringLength: {
            min: 6,

            message: $(this.el)
              .find('[name=passwd]')
              .attr('data-fv-stringlength-message')
          }
        }
      },

      passwdRepeat: {
        verbose: false,

        validators: {
          identical: {
            field: 'passwd',

            message: $(this.el)
              .find('[name=passwdRepeat]')
              .attr('data-fv-identical-message')
          }
        }
      }
    };

    return fields;
  }

  _sendUsernameFormFields() {
    const fields = {
      Email: {
        verbose: false,

        validators: {
          notEmpty: {
            message: $(this.el)
              .find('[name=Email]')
              .attr('data-fv-notempty-message')
          },

          regexp: {
            regexp: /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i, // eslint-disable-line

            message: $(this.el)
              .find('[name=Email]')
              .attr('data-fv-regexp-message')
          }
        }
      }
    };

    return fields;
  }

  _contactFormFields() {
    const fields = {
      realname: {
        verbose: false,

        validators: {
          notEmpty: {
            message: $(this.el)
              .find('[name=realname]')
              .attr('data-fv-notempty-message')
          }
        }
      },

      email: {
        verbose: false,

        validators: {
          notEmpty: {
            message: $(this.el)
              .find('[name=email]')
              .attr('data-fv-notempty-message')
          },

          regexp: {
            regexp: /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i, // eslint-disable-line

            message: $(this.el)
              .find('[name=email]')
              .attr('data-fv-regexp-message')
          }
        }
      },

      subject: {
        verbose: false,

        validators: {
          notEmpty: {
            message: $(this.el)
              .find('[name=subject]')
              .attr('data-fv-notempty-message')
          }
        }
      },

      question: {
        verbose: false,

        validators: {
          notEmpty: {
            message: $(this.el)
              .find('[name=question]')
              .attr('data-fv-notempty-message')
          }
        }
      }
    };

    return fields;
  }

  _signupFormFields() {
    const fields = {
      RegUsername: {
        row: '.col-xs-6',

        verbose: false,

        validators: {
          notEmpty: {
            message: $(this.el)
              .find('[name=RegUsername]')
              .attr('data-fv-notempty-message')
          },

          callback: {
            message: $(this.el)
              .find('[name=RegUsername]')
              .attr('data-fv-callback-message'),

            callback: validator.checkUsername
          }
        }
      },

      RegPassword: {
        row: '.col-xs-6',

        verbose: false,

        validators: {
          notEmpty: {
            message: $(this.el)
              .find('[name=RegPassword]')
              .attr('data-fv-notempty-message')
          },

          stringLength: {
            min: 6,

            message: $(this.el)
              .find('[name=RegPassword]')
              .attr('data-fv-stringlength-message')
          },

          different: {
            field: 'RegUsername',

            message: $(this.el)
              .find('[name=RegPassword]')
              .attr('data-fv-different-message')
          }
        }
      },

      RegEmail: {
        row: '.col-xs-12',

        verbose: false,

        validators: {
          notEmpty: {
            message: $(this.el)
              .find('[name=RegEmail]')
              .attr('data-fv-notempty-message')
          },

          callback: {
            message: $(this.el)
              .find('[name=RegEmail]')
              .attr('data-fv-callback-message'),

            callback: validator.checkEmail
          }
        }
      },

      birthday: {
        row: '.col-xs-6',

        verbose: false,

        validators: {
          notEmpty: {
            message: $(this.el)
              .find('[name=birthday]')
              .attr('data-fv-notempty-message')
          },

          callback: {
            message: $(this.el)
              .find('[name=birthday]')
              .attr('data-fv-date-message'),

            callback: validator.checkDate
          }
        }
      },

      bday: {
        row: '.col-xs-4',

        verbose: false,

        validators: {
          notEmpty: {
            message: $(this.el)
              .find('[name=bday]')
              .attr('data-fv-notempty-message')
          }
        }
      },

      bmonth: {
        row: '.col-xs-4',

        verbose: false,

        validators: {
          notEmpty: {
            message: $(this.el)
              .find('[name=bmonth]')
              .attr('data-fv-notempty-message')
          }
        }
      },

      byear: {
        row: '.col-xs-4',

        verbose: false,

        validators: {
          notEmpty: {
            message: $(this.el)
              .find('[name=byear]')
              .attr('data-fv-notempty-message')
          }
        }
      },

      Ich_suche: {
        row: '.col-xs-12',

        verbose: false,

        validators: {
          notEmpty: {
            message: $(this.el)
              .find('[name=Ich_suche]')
              .attr('data-fv-notempty-message')
          }
        }
      },

      Geschlecht: {
        row: '.col-xs-6',

        verbose: false,

        validators: {
          notEmpty: {
            message: $(this.el)
              .find('[name=Geschlecht]')
              .attr('data-fv-notempty-message')
          }
        }
      },

      Partner: {
        row: '.col-xs-6',

        verbose: false,

        validators: {
          notEmpty: {
            message: $(this.el)
              .find('[name=Partner]')
              .attr('data-fv-notempty-message')
          }
        }
      },

      place_id: {
        validators: {
          notEmpty: {
            message: $(this.el)
              .find('[name=Geosearch]')
              .attr('data-fv-notempty-message')
          }
        }
      },

      Geosearch: {
        row: '.col-xs-12',

        verbose: false,

        validators: {
          notEmpty: {
            message: $(this.el)
              .find('[name=Geosearch]')
              .attr('data-fv-notempty-message')
          }
        }
      },

      agb_ok: {
        row: '.col-xs-12',

        verbose: false,

        validators: {
          notEmpty: {
            message: $(this.el)
              .find('[name=agb_ok]')
              .attr('data-fv-notempty-message')
          }
        }
      }
    };

    return fields;
  }
  /* eslint-enable */
}



// WEBPACK FOOTER //
// ./src/main/javascripts/modules/formvalidation.js